import { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "../ui/dialog";
import { AuthPanel } from "./AuthPanel";

export const LoginDialog = ({ trigger }) => {
  const [open, setOpen] = useState(false);
  return (
    <>
      {trigger(() => setOpen(true))}
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="max-w-sm" data-testid="login-dialog">
          <DialogHeader>
            <DialogTitle className="font-serif text-xl">Welcome to Hotel Vijayshree Inn</DialogTitle>
            <DialogDescription>Sign in or create an account to book rooms and manage your stays.</DialogDescription>
          </DialogHeader>
          <AuthPanel returnPath={typeof window !== "undefined" ? window.location.pathname : "/"} onSuccess={() => setOpen(false)} testPrefix="header" />
        </DialogContent>
      </Dialog>
    </>
  );
};
